import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import InvaildCouponIcon from '../../assets/applyError.png'
import CouponSuccessIcon from '../../assets/coupon_success.png'

const ApplyCouponPopUp = ({ open, onClose,couponAppliedSuccess, CouponText,setShowCouponPopFlag,handleCloseCouponPopup }) => {


    /* const couponApplied=false */
/*     const CouponText=()=>{
        return(
            <>
             Coupon code <strong>{couponCode}</strong> does not exist for this item.
          Please try again!
          </>
        )
    } */

  return (
    <Dialog
      open={true}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          padding: "20px",
          width: 340,
          textAlign: "center",
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
           
            width: 92,
            height: 92,
            borderRadius: "50%",
            margin: "0 auto 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
        {couponAppliedSuccess?<img src={CouponSuccessIcon} style={{width:"100px"}}/>:<img src={InvaildCouponIcon} style={{width:"100px"}}/>}
        </Box>

        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            marginBottom: 1,
            color: "#1C1C1C",
          }}
        >
         { couponAppliedSuccess?<span>Congratulations</span>:<span style={{color:"#A81137"}}>Oops!</span>}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#666",
            maxWidth: 260,
            margin: "0 auto",
          }}
        >
        <CouponText/>
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          onClick={(e)=>{handleCloseCouponPopup()}}
          variant="contained"
          sx={{
            backgroundColor: "#00A651",
            color: "#fff",
            borderRadius: "10px",
            width: 120,
            "&:hover": { backgroundColor: "#00994b" },
          }}
        >
         {couponAppliedSuccess?"OK":"Try Again"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApplyCouponPopUp;
